module.exports = __webpack_public_path__ + "img/SB.947a3c13.svg";